var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScript = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.832 1.4A6.63 6.63 0 0 0 1.2 8.032V49.36h6.072M12.92 49.36h17.36a6.306 6.306 0 0 0 6.304-6.305V4.831M36.672 1.4a6.057 6.057 0 0 1 2.776 11.44M9.144 11h19.2M9.144 20.4h19.2M9.144 29.794h19.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M7.272 44.937v9.568l2.824-2.392 2.824 2.392v-9.568"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.272 44.937v9.568l2.824-2.392 2.824 2.392v-9.568"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10.096 45.233a4.648 4.648 0 1 0 0-9.296 4.648 4.648 0 0 0 0 9.296M7.832 1.4H36.6"
})));
export { SvgScript as ReactComponent };
export default __webpack_public_path__ + "67ced3f23f731c5e530c01c4afbd95ae.svg";